import React from 'react';
import _ from 'lodash';

export function ValueComponent({ value, valueFormatter }: any) {

    return (
        <p>
            {valueFormatter ? valueFormatter(value) : value}
        </p>
    )
}
